import { type FC, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useQuery } from 'react-query'

import { Button } from 'components/Button/Button'
import TextArea from 'components/Form/TextArea/TextArea'
import { RadioButton } from 'components-ref/atoms'
import { getReportTypes } from 'services/endpoints/report'
import { type ReportType } from 'types/api/report'

import styles from './report.module.scss'

export type ReportContext = 'user' | 'content'

interface Props {
    type: ReportContext
    confirmFn: (_message: string, _reportType: number) => void
    closeFn: () => void
}

const Report: FC<Props> = ({
    type,
    confirmFn,
    closeFn
}) => {
    const [selectedOption, setSelectedOption] = useState(0)
    const [message, setMessage] = useState<string>('')

    const { t } = useTranslation()

    const {
        data: reportTypesData,
        isLoading
    } = useQuery(
        ['reportTypes', type],
        async () => await getReportTypes(type)
    )

    if (isLoading) {
        return (
            <div className={styles.report}>
                Loading...
            </div>
        )
    }

    return (
        <div className={styles.report}>
            <div className={styles.options}>
                {reportTypesData?.map(
                    (option: ReportType) => (
                        <div
                            key={option.id}
                            className={styles.option}
                            onClick={() =>
                                setSelectedOption(option.id)
                            }
                        >
                            <RadioButton
                                active={
                                    selectedOption === option.id
                                }
                            />

                            <div className={styles.label}>
                                {option.text}
                            </div>
                        </div>
                    )
                )}
            </div>

            <div className={styles.message}>
                <TextArea
                    label={t('message')}
                    id='report-modal-textarea'
                    placeholder={t('message')}
                    maxChar={160}
                    shouldRemoveLabelOnFocus={true}
                    value={message}
                    changeFn={(val: string) =>
                        setMessage(val)
                    }
                />
            </div>

            <div className={styles.footer}>
                <Button
                    text={t('cancel')}
                    color='grey'
                    font='mont-14-normal'
                    width='10'
                    height='3'
                    clickFn={closeFn}
                />

                <Button
                    text={t('report')}
                    color='black'
                    font='mont-14-normal'
                    width='13'
                    height='3'
                    clickFn={() =>
                        confirmFn(
                            message,
                            selectedOption
                        )
                    }
                    disabled={!selectedOption}
                />
            </div>
        </div>
    )
}

export default Report